module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KR-23f2fc6537bfc4eaaf3aa689eded95f1.png";